import React,{useEffect} from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Lab_Tests from "./Lab_Tests"
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import FreeHS_Msg from '../Components/FreeHS_Msg'
import styles from "assets/jss/material-kit-react/views/landingPage.js";
import useWindowDimensions from "../../useWindowDimensions";


// Sections for this page
// import ProductSection from "./Sections/ProductSection.js";
// import TeamSection from "./Sections/TeamSection.js";
// import WorkSection from "./Sections/WorkSection.js";
import molecule_1 from 'assets/img/animations/virus (13).png';



import molecule_6 from 'assets/img/animations/virus (6).png';

import molecule_7 from 'assets/img/animations/virus (9).png';

import COVID19_PCR from '../COVID19_PCR/Covid19_PCR.js'
import test_info from 'assets/img/test_info.png';


const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function LandingPage(props) {
  const classes = useStyles();
  const { width } = useWindowDimensions();
  const { ...rest } = props;
  useEffect(()=>{
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  },[])
  return (
    <div style={{backgroundColor:""}}>
      <Header
        // color="transparent"
        routes={dashboardRoutes}
        brand="Material Kit React"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
        <div  >
         <img
                src={require("assets/img/info.jpeg")}
                style={{ 
                  minWidth:"100%",
                maxWidth: "100%",
                height:width<500?200 : "50%",
                borderRadius: "calc(.25rem - 1px)",
                boxShadow:
                "0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
                marginTop:width<500?"22%":"8%",
                opacity:width<500?0.5:0.5
            
            }}
              />
              {/* <h1 className={classes.title} style={{position:"absolute"}}>Message From CEO </h1> */}

        {/* <div className={classes.container}>
          <GridContainer>
            
            <GridItem>
            
           
              <h1 className={classes.title} style={{marginTop:-40}}>Message From CEO </h1>
              
            
            
            </GridItem>
          </GridContainer>
        </div> */}
      </div>
      {/* <Parallax filter image={require("assets/img/info.jpeg")} style={{marginTop:width<500?90:100}}
>
        <div className={classes.container}>
          <GridContainer>
            
            <GridItem>
        
              <h1 className={classes.title} style={{marginTop:-20}}>Find a Test</h1>
              <h4>
               Information of Test Prices, Delivery Time & Sample Type etc.
              </h4>
             
            
            </GridItem>
          </GridContainer>
        </div>
      </Parallax> */}
      {/* <div className={classNames(classes.main, classes.mainRaised)} style={{marginTop:"-180px"}}> */}
      {/* <div className={classNames(classes.main, classes.mainRaised)} style={{marginTop:width<500?-180:-60}}> */}
      <div className={classNames(classes.main, classes.mainRaised)} style={{marginTop:width<500?-50:-500}}>

        <div className={classes.container} style={{paddingTop:"1em", paddingBottom:"5em"}} >

          {/* <br /> */}
          {/* <img src={test_info} style={{
  width: '7em',}} class="center"/> */}
<p style={{color:"#196c91",fontSize:window.innerWidth <= 768?"1em":"1.35em",textAlign:"center",marginTop:"2%",fontWeight:"bold"}}>Welcome to FSLS Job Portal </p>
          <br />
          

  {/* table call ho rha in which api call and fill the data state and display table in this screen */}
            <Lab_Tests />
            {/* this is for Free Home Sampling section */}
            {/* <FreeHS_Msg /> */}
         
        </div>
      </div>
      <Footer />
    </div>
  );
}
